import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';


@Injectable()
export class AlertService {

    private subject = new Subject<any>();
    TYPE = {
        SUCCESS: 'success',
        INFO: 'info',
        DANGER: 'danger',
    }
    alert = {
        type: '',
        message: '',
        show: false
    }
    constructor() { }

    sendMessage(message: any) {
        this.subject.next(message);
    }

    clearMessage() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
    
    setAlert(type: string, message: string): void {
        this.alert.message = message;
        this.alert.type = type;
        this.alert.show = true;
        this.sendMessage(this.alert);
    }
}
